module.exports = __webpack_public_path__ + "img/MG-TITLE-02.3d7181f1.png";